export const InititateFacebookAuth = () => {
  const redirect_uri = import.meta.env.VITE_FACEBOOK_REDIRECT_URL
  const scope = import.meta.env.VITE_FACEBOOK_SCOPE_LIST

  const facebookAuthUrl = `https://www.facebook.com/dialog/oauth?client_id=564741736285629&redirect_uri=${redirect_uri}&response_type=token&scope=${scope}`

  window.location.href = facebookAuthUrl

  return Promise.resolve()
}
